import { createFileRoute, Outlet } from "@tanstack/react-router";

import { StepFlowLayout } from "~/components/layouts/StepFlowLayout";
import { useFlowStart } from "~/hooks/use-flow-start";

export const Route = createFileRoute("/(authenticated)/verbind-account")({
  component: VerbindAccountLayout,
});

function VerbindAccountLayout() {
  useFlowStart("verbind_account");

  return (
    <StepFlowLayout currentStep={1} totalSteps={1}>
      <Outlet />
    </StepFlowLayout>
  );
}
